import { render, staticRenderFns } from "./MoleculeEditionAssetCommentsCreate.vue?vue&type=template&id=02f4441a&"
import script from "./MoleculeEditionAssetCommentsCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetCommentsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports